<template>
  <div class="DocumentElement -password">
    <div class="max-w-xs mx-auto pb-4">
      <form class="space-y-2">
        <div class="text-center text-bc-blue grid grid-cols-1">
          <div><aw-icon icon="embed" class="w-12 h-12 mr-2  text-bc-blue" /></div>
          {{$t('Embed content - enter valid url')}}
        </div>

        <div class="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
          <div class="sm:col-span-6">
            <div class="mt-1 flex flex-wrap">
              <textarea
                class="form-control rounded-md shadow-sm text-center"
                :placeholder="$t('Enter a valid url')"
                v-model="url"
              />
            </div>
          </div>
        </div>

        <div class="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
          <div class="sm:col-span-6">
            <div class="mt-1 flex">
              <button
                @click.prevent.stop="updateUrl(close)"
                class="btn btn-primary block w-full"
              >
                {{$t('Save')}}
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>
<script>
import Embed from '../../mixins/Embed'
import EmbedLogic from '../../mixins/EmbedLogic'

export default {
  mixins: [Embed, EmbedLogic]
}
</script>
